import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  viewRewardVoucher,
  updateRewardVoucher,
} from "../../Redux/Actions/rewardsAction";
import { ToFirstCapital } from "../../Utils/helpers";
import MainLayout from "../../Layout/mainLayout";
import "./viewReward.css";

const ViewRewards = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const rewardState = useSelector((state) => state.rewards || {});

  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [showAllTerms, setShowAllTerms] = useState(false);
  const [showAllRedeem, setShowAllRedeem] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewRewardVoucher(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (rewardState.rewardDetails?.status) {
      setStatus(rewardState.rewardDetails.status);
    }
  }, [rewardState.rewardDetails]);

  const data = rewardState.voucherDetails || {};

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = () => {
    setIsUpdating(true);
    setShowConfirm(false);
    dispatch(updateRewardVoucher(data._id, selectedStatus)).finally(() =>
      setIsUpdating(false)
    );
  };

  return (
    <MainLayout>
      <div className="vrv-wrapper" style={{ opacity: isUpdating ? 0.6 : 1, pointerEvents: isUpdating ? "none" : "auto" }}>

        <div className="vrv-header">
          <div className="vrv-header-left">
            <Link to="/rewards" className="vrv-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vrv-header-divider" />
            <div>
              <div className="vrv-breadcrumb">Rewards / List / View</div>
              <h1 className="vrv-title">{data.title || "Reward Voucher"}</h1>
            </div>
          </div>
        </div>

        <div className="vrv-hero-card">
          <div className="vrv-hero-left">
            <div>
              <div className="vrv-hero-label">Voucher Code</div>
              <div className="vrv-hero-value">{data.voucher || "—"}</div>
            </div>
            {data.reward_points !== undefined && (
              <div className="vrv-points-badge">
                <span className="vrv-points-label">Points</span>
                {data.reward_points}
              </div>
            )}
          </div>
          <div className="vrv-hero-meta">
            {data.category && (
              <div className="vrv-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
                </svg>
                {data.category}
              </div>
            )}
            {data.country?.country_name && (
              <div className="vrv-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
                {data.country.country_name}
              </div>
            )}
          </div>
        </div>

        <div className="vrv-grid-layout">

          <div className="vrv-col">

            {data.image && (
              <div className="vrv-card">
                <div className="vrv-card-header">
                  <span className="vrv-card-badge">01</span>
                  <h2 className="vrv-card-title">Voucher Image</h2>
                </div>
                <div className="vrv-image-wrap">
                  <img src={data.image} alt={data.title} className="vrv-image" />
                </div>
              </div>
            )}

            <div className="vrv-card">
              <div className="vrv-card-header">
                <span className="vrv-card-badge">{data.image ? "02" : "01"}</span>
                <h2 className="vrv-card-title">Voucher Details</h2>
              </div>
              <div className="vrv-info-grid">
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Voucher Code</span>
                  <span className="vrv-code-value">{data.voucher || "No Data"}</span>
                </div>
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Reward Points</span>
                  <span className="vrv-info-value">{data.reward_points ?? "No Data"}</span>
                </div>
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Title</span>
                  <span className="vrv-info-value">{data.title || "No Data"}</span>
                </div>
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Category</span>
                  <span className="vrv-info-value">{data.category || "No Data"}</span>
                </div>
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Position</span>
                  <span className="vrv-info-value">{data.position || "No Data"}</span>
                </div>
                <div className="vrv-info-item">
                  <span className="vrv-info-label">Country</span>
                  <span className="vrv-info-value">{data.country?.country_name || "No Data"}</span>
                </div>
                <div className="vrv-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vrv-info-label">Brochure</span>
                  {data.brochure ? (
                    <a href={data.brochure} target="_blank" rel="noopener noreferrer" className="vrv-brochure-link">
                      <svg className="vrv-brochure-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      View Brochure
                      <svg className="vrv-external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  ) : (
                    <span className="vrv-no-brochure">No Brochure Available</span>
                  )}
                </div>
                <div className="vrv-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vrv-info-label">Description</span>
                  <p className="vrv-description">{data.description || "No Data"}</p>
                </div>
              </div>
            </div>

          </div>

          <div className="vrv-col">

            <div className="vrv-card">
              <div className="vrv-card-header">
                <span className="vrv-card-badge">{data.image ? "03" : "02"}</span>
                <h2 className="vrv-card-title">Terms & Conditions</h2>
              </div>
              {Array.isArray(data.terms_and_conditions) && data.terms_and_conditions.length > 0 ? (
                <>
                  <ul className="vrv-list">
                    {data.terms_and_conditions
                      .slice(0, showAllTerms ? data.terms_and_conditions.length : 5)
                      .map((term, idx) => (
                        <li key={idx} className="vrv-list-item">{term}</li>
                      ))}
                  </ul>
                  {data.terms_and_conditions.length > 5 && (
                    <div className="vrv-view-more-wrap">
                      <button className="vrv-view-more-btn" onClick={() => setShowAllTerms(!showAllTerms)}>
                        <span className="vrv-chevron">{showAllTerms ? "▲" : "▼"}</span>
                        {showAllTerms ? "View Less" : `View More (${data.terms_and_conditions.length - 5} more)`}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="vrv-no-data">No Terms & Conditions Available</p>
              )}
            </div>

            <div className="vrv-card">
              <div className="vrv-card-header">
                <span className="vrv-card-badge">{data.image ? "04" : "03"}</span>
                <h2 className="vrv-card-title">How to Redeem</h2>
              </div>
              {Array.isArray(data.how_to_redeem) && data.how_to_redeem.length > 0 ? (
                <>
                  <ul className="vrv-list">
                    {data.how_to_redeem
                      .slice(0, showAllRedeem ? data.how_to_redeem.length : 5)
                      .map((step, idx) => (
                        <li key={idx} className="vrv-list-item">{step}</li>
                      ))}
                  </ul>
                  {data.how_to_redeem.length > 5 && (
                    <div className="vrv-view-more-wrap">
                      <button className="vrv-view-more-btn" onClick={() => setShowAllRedeem(!showAllRedeem)}>
                        <span className="vrv-chevron">{showAllRedeem ? "▲" : "▼"}</span>
                        {showAllRedeem ? "View Less" : `View More (${data.how_to_redeem.length - 5} more)`}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="vrv-no-data">No Redemption Steps Available</p>
              )}
            </div>

            <div className="vrv-card">
              <div className="vrv-card-header">
                <span className="vrv-card-badge">{data.image ? "05" : "04"}</span>
                <h2 className="vrv-card-title">Status</h2>
              </div>
              <div className="vrv-info-item">
                <span className="vrv-info-label">Update Status</span>
                <div className="vrv-select-wrap">
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="vrv-select"
                    disabled={isUpdating}
                  >
                    <option value="" disabled>Select Status</option>
                    {["active", "inactive"].map((stat) => (
                      <option key={stat} value={stat}>
                        {ToFirstCapital(stat)}
                      </option>
                    ))}
                  </select>
                  <svg className="vrv-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                {isUpdating && (
                  <div className="vrv-updating-text">
                    <div className="vrv-updating-dot" />
                    Updating status…
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      {showConfirm && (
        <div className="vrv-modal-backdrop">
          <div className="vrv-modal">
            <div className="vrv-modal-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <h3 className="vrv-modal-title">Confirm Status Change</h3>
            <p className="vrv-modal-text">
              Are you sure you want to change status to{" "}
              <strong>"{ToFirstCapital(selectedStatus)}"</strong>?
            </p>
            <div className="vrv-modal-actions">
              <button className="vrv-btn vrv-btn--confirm" onClick={confirmStatusChange} disabled={isUpdating}>
                Confirm
              </button>
              <button className="vrv-btn vrv-btn--cancel" onClick={() => setShowConfirm(false)} disabled={isUpdating}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ViewRewards;